import { MnpInCartModule } from './mnpIn'
import { OrderCartModule } from './order'
import { ActivationCartModule } from './activation'
import { initialState } from './initialstate'

const kwkPromos = [
  11211,
  24108,
  13101,
  14007,
  14008,
  14009,
  25101,
  26107,
  26108,
  26109,
  15201,
  15202,
  27101,
  27102,
  27213, // BW 6 Monate 50% GG STAGE
  15513, // BW 6 Monate 50% GG INT
  27214, // BW 6 Monate 50% 5 GB STAGE
  15514, // BW 6 Monate 50% 5 GB INT
  27215, // BW 6 Monate 50% 15 GB STAGE
  15515, // BW 6 Monate 50% 15 GB INT
  25759, // BW 2 Monate 50% GG STAGE
  13705, // BW 2 Monate 50% GG INT
  27209, // BW 2 Monate 50% 5 GB STAGE
  15509, // BW 2 Monate 50% 5 GB INT
  27210, // BW 2 Monate 50% 15 GB STAGE
  15510 // BW 2 Monate 50% 15 GB INT
]

const CartModule = {
  namespaced: true,
  modules: {
    mnpIn: MnpInCartModule,
    order: OrderCartModule,
    activation: ActivationCartModule
  },
  actions: {
    processQueryResult ({ state, commit, root, rootState }, { tariff, tariffoptions, promotions }) {
      const filterConfig = rootState.promotion.filterConfig
      const initCopy = JSON.parse(JSON.stringify(initialState))
      const targetTariff = tariff
      if (!targetTariff.connectionFee) {
        targetTariff.connectionFee = 0
      }
      const targetTariffoptions = Array.isArray(tariffoptions) ? tariffoptions : []
      let targetPromotions = promotions || []
      targetPromotions = targetPromotions.filter(promo => {
        if (filterConfig && filterConfig.length > 0) {
          return filterConfig.includes(promo.promotionId)
        }
        return true
      })
      const newPrice = initCopy.price
      const newVolume = initCopy.volume
      const newLimitedVolume = initCopy.limitedVolume
      let newPromoPrice = initCopy.promoPrice
      const additionalPriceStairways = initCopy.additionalPriceStairways
      let newStartingBonus = 0
      // Initialize values with TargetTariff
      newVolume.amount += targetTariff.volumes[0].amount
      newVolume.promoAmount += targetTariff.volumes[0].amount
      newVolume.unit = targetTariff.volumes[0].formattedUnit || 'GB'
      newLimitedVolume.unit = targetTariff.volumes[0].formattedUnit || 'GB'
      newPrice.amount += targetTariff.basicFee
      newPromoPrice.promoAmount += targetTariff.basicFee

      // Add Tariffoptions
      if (targetTariffoptions && targetTariffoptions.length > 0) {
        targetTariffoptions.forEach(option => {
          newPrice.amount += option.price
          newPromoPrice.promoAmount += option.price
          if (option.volumes && option.volumes.length > 0) {
            option.volumes.forEach(volume => {
              if (volume.unit === newVolume.unit) {
                newVolume.amount += volume.amount
                newVolume.promoAmount += volume.amount
              }
            })
          }
        })
      }

      // Add Promotions
      targetPromotions.forEach(promo => {
        promo.incentives.forEach(incentive => {
          if (kwkPromos.includes(promo.promotionId) && incentive.targetFee === 'ONE_TIME_FEE' && incentive.type === 'credit') {
            incentive.targetFee = 'MONTHLY_FEE'
            // promo.duration = { amount: 1, unit: 'MONTH', formattedUnit: 'Monat' } // da die duration aktuell korrekt zurueck kommt, wird das hier nicht benoetigt (evtl zukuenftig wieder)
          }
          if (promo.duration && promo.duration.amount && promo.duration.amount > 0) {
            // Limited
            if (incentive.type === 'volume' && (newLimitedVolume.duration === 0 || newLimitedVolume.duration === promo.duration.amount) && newLimitedVolume.unit === incentive.unit) {
              newLimitedVolume.duration = promo.duration.amount
              newLimitedVolume.durationUnit = promo.duration.formattedUnit
              newLimitedVolume.promoAmount += incentive.amount
            } else if (incentive.type === 'credit' && (incentive.targetFee === 'MONTHLY_FEE')) {
              const promoDuration = promo.duration.amount + 1
              // Stairway Handling
              if (additionalPriceStairways.length === 0) {
                // First stairway found
                additionalPriceStairways.push({
                  duration: promoDuration,
                  durationUnit: promo.duration.formattedUnit,
                  promoAmount: newPromoPrice.promoAmount > incentive.discount ? newPromoPrice.promoAmount - incentive.discount : 0
                })
              } else {
                // More stairways found
                let stairwayAdded = false
                additionalPriceStairways.forEach((stairway, index) => {
                  if (stairwayAdded) { return } // Stop processing if already added
                  if (stairway.duration < promoDuration) {
                    // Add amount to shorter stairways and continue processing
                    stairway.promoAmount = stairway.promoAmount > incentive.discount ? stairway.promoAmount - incentive.discount : 0
                  } else if (stairway.duration === promoDuration) {
                    // Add amount to stairway with same duration and stop processing
                    stairway.promoAmount = stairway.promoAmount > incentive.discount ? stairway.promoAmount - incentive.discount : 0
                    stairwayAdded = true
                  } else if (stairway.duration > promoDuration) {
                    // Add new stairway before current element and based on the values of the current element and stop processing
                    additionalPriceStairways.splice(index, 0, {
                      duration: promoDuration,
                      durationUnit: promo.duration.formattedUnit,
                      promoAmount: stairway.promoAmount > incentive.discount ? stairway.promoAmount - incentive.discount : 0
                    })
                    stairwayAdded = true
                  }
                })
                if (!stairwayAdded) {
                  // if stairway was not added until here, it is the new end element and based on regular price
                  additionalPriceStairways.push({
                    duration: promoDuration,
                    durationUnit: promo.duration.formattedUnit,
                    promoAmount: newPromoPrice.promoAmount > incentive.discount ? newPromoPrice.promoAmount - incentive.discount : 0
                  })
                }
              }
            }
          } else {
            // Unlimited
            if (incentive.type === 'volume' && newVolume.unit === incentive.unit) {
              newVolume.promoAmount += incentive.amount
            } else if (incentive.type === 'credit' && incentive.targetFee === 'MONTHLY_FEE') {
              newPromoPrice.promoAmount = newPromoPrice.promoAmount > incentive.discount ? newPromoPrice.promoAmount - incentive.discount : 0
              additionalPriceStairways.forEach(stairway => {
                stairway.promoAmount = stairway.promoAmount > incentive.discount ? stairway.promoAmount - incentive.discount : 0
              })
            } else if (incentive.type === 'credit' && incentive.targetFee === 'ONE_TIME_FEE') {
              newStartingBonus += incentive.discount
            }
          }
        })
      })

      // Reorganize Stairways for frontend
      if (additionalPriceStairways.length > 0) {
        const finalPromoAmount = newPromoPrice.promoAmount
        newPromoPrice = additionalPriceStairways.shift()
        let duration = newPromoPrice.duration
        let durationUnit = newPromoPrice.durationUnit
        additionalPriceStairways.forEach(stairway => {
          let tmp = stairway.duration
          stairway.duration = duration
          duration = tmp
          tmp = stairway.durationUnit
          stairway.durationUnit = durationUnit
          durationUnit = tmp
        })
        additionalPriceStairways.push({
          duration: duration,
          durationUnit: durationUnit,
          promoAmount: finalPromoAmount
        })
      }

      return {
        targetTariff: targetTariff,
        targetTariffoptions: targetTariffoptions,
        targetPromotions: targetPromotions,
        promoBenefits: { newVolume, newLimitedVolume, newPrice, newPromoPrice, additionalPriceStairways, newStartingBonus }
      }
    }
  }
}

export {
  CartModule, initialState
}
